'use client';

import type { ReactNode } from 'react';

interface SetupContainerProps {
  children: ReactNode;
}

export function SetupContainer({ children }: SetupContainerProps) {
  return (
    <div className="flex min-h-dvh w-full flex-1 flex-col overflow-y-auto bg-background">
      {children}
    </div>
  );
}
